import React, { FC } from 'react'
import styles from '../Modal/Preferences.module.scss'
import CaretDownIcon from 'svg/caretDown.svg'
import { Locale } from 'types/Shared/Locale'

type CountryInputProps = {
  data: Locale['availableCountries']
  onChange: (ev: React.SyntheticEvent<HTMLElement>) => void
  selected: string
}
const NAME = 'countryCode'

const CountryInput: FC<CountryInputProps> = (props) => {
  const { data, onChange, selected } = props
  const dataArray = Object.entries(data) || []
  return (
    <div className={styles.preferencesInputBox}>
      <label htmlFor={NAME} className={styles.preferencesInputLabel}>
        <span>Country*</span>
        <div className={styles.preferencesInputField}>
          <input type='text' value={data[selected]} disabled />
          <CaretDownIcon />
        </div>
      </label>

      <select
        name={NAME}
        id={NAME}
        value={selected}
        onChange={onChange}
        className='defaultInputSelectField'
        tabIndex={0}
      >
        {dataArray.map((item) => {
          const [key, name] = item
          return (
            <option key={key} value={key}>
              {String(name)}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default CountryInput
